import type { ReactNode } from 'react';

export const symbol_code_blocks: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m330-480 70-70q9-9 9-22t-9-22q-9-9-21.83-9-12.84 0-22.17 9l-93 93q-5 5-7 10.13-2 5.14-2 11 0 5.87 2 10.87 2 5 7 10l94 94q9.33 9 22.17 9 12.83 0 21.83-9 9-9 9-22t-9-22l-71-71Zm300 0-71 71q-9 9-9 22t9 22q9 9 21.83 9 12.84 0 22.17-9l94-94q5-5 7-10.13 2-5.14 2-11 0-5.87-2-10.87-2-5-7-10l-94-94q-4-5-10-7t-12-2q-6 0-11.5 2t-10.17 6.8q-9.33 9.6-9.33 22.4 0 12.8 9 21.8l71 71ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
